import { toast } from 'react-toastify';
import { v4 as uuid } from 'uuid';

import { TSaveToastMessages } from '@/shared/hooks/use-save-toast/use-save-toast.types';
import { showToastLoading } from '@/shared/utils/toast';

// A fresh toast id per call (per invocation, not per render) so overlapping
// saves each report their own outcome and update targets the live toast.
export const useSaveToast = () => {
  const run = async <T>(
    save: () => Promise<T>,
    messages: TSaveToastMessages,
  ): Promise<T> => {
    const toastId = uuid();
    showToastLoading(messages.loading, toastId);

    try {
      const result = await save();
      toast.update(toastId, {
        render: messages.success,
        type: 'success',
        isLoading: false,
        autoClose: 5000,
      });
      return result;
    } catch (error) {
      toast.update(toastId, {
        render: messages.error,
        type: 'error',
        isLoading: false,
        autoClose: 5000,
      });
      throw error;
    }
  };

  return { run };
};
